import { useState } from "react";
import SegmentedButton from "@/components/SegmentedButton";
import { useFlags } from "@/hooks/useFeatureFlags";
import GroupEmailComposer from "@/pages/people/membership-services/committees/_components/GroupEmailComposer";
import SectionGovernanceEmailForm from "./SectionGovernanceEmailForm";

export type GroupEmailMode = "committees" | "governance";

export default function GroupEmailPageForm() {
  const flags = useFlags();
  const governanceEnabled = flags["backoffice-section-governance"] === true;
  const [mode, setMode] = useState<GroupEmailMode>("committees");
  const effectiveMode: GroupEmailMode = governanceEnabled ? mode : "committees";

  return (
    <div className="flex w-full flex-col gap-6" data-testid="group-email-page-form">
      {governanceEnabled && (
        <SegmentedButton
          fullWidth
          ariaLabel="Group email type"
          value={effectiveMode}
          onChange={(value) => {
            if (value === "committees" || value === "governance") setMode(value);
          }}
          options={[
            { label: "Committees", value: "committees" },
            { label: "Section Governance", value: "governance" }
          ]}
        />
      )}

      {effectiveMode === "committees" ? (
        <GroupEmailComposer active layout="page" />
      ) : (
        <SectionGovernanceEmailForm active />
      )}
    </div>
  );
}
